"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@angular/material");
class NotificationDialogData {
}
exports.NotificationDialogData = NotificationDialogData;
class NotificationDialog {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
    }
    onClick(isPos) {
        this.dialogRef.close({ response: isPos, checkboxValue: this.checkboxValue });
    }
}
exports.NotificationDialog = NotificationDialog;
